<template>
<div class="Renew">
    <div class="renewHeader">
        <div class="content">
            <div>版本订阅</div>
            <div @click="goToHome" class="home">
                <i class="el-icon-arrow-left"></i>
                <span>返回</span>
            </div>
        </div>
    </div>
    <keep-alive include="BBActivityList">
        <router-view :param="param"></router-view>
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'Renew',
    data() {
        return {
            param: {}
        }
    },
    mounted() {
    },
    methods: {
        goToHome() {
            // this.$router.push({name: 'Index'})
            this.$router.back()
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Renew {
    padding-top: 48px;
    .renewHeader {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 48px;
        background: #fff;
        box-shadow: 0px 1px 8px 0px rgba(0, 18, 41, 0.1);
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        .content {
            width: 100%;
            padding: 0 48px;
            margin: auto;
            height: 48px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .home{
                &:hover{
                    cursor: pointer;
                    color: #409EFF;
                }
            }
        }
    }
}
</style>
